var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useLanguage } from '@base/LanguageProvider';
import { CellStatus, SettingType, TagType, } from '@common/api';
import * as baobab from '@data/baobab/baobab';
import { cellKeys } from '@data/cell';
import DatePicker from '@shared/input/DatePicker';
import ModalManager from '@shared/modal/Manager';
import Modal from '@shared/modal/Modal';
import Tags from '@shared/tags/Tags';
import { useTagActions } from '@data/tag/tagActions';
import { useTagContext } from '@data/tag/tagContext';
import SelectInput from '@shared/input/SelectInput';
import TextArea from '@shared/input/TextArea';
import TextInput from '@shared/input/TextInput';
import ModalFooter from '@shared/modal/ModalFooter';
import ModalHeader from '@shared/modal/ModalHeader';
import { FormField, FormFieldErrorHelp, FormFieldLabel } from '@styled/Form';
import { ModalBody } from '@styled/Modal';
//@ts-ignore
import { useRoot } from 'baobab-react/hooks';
import React, { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { FeatureWrapper } from '../../base/FeatureWrapper';
import { useSetting } from '../../data/hooks/settings';
import { createCell, updateCell } from './cellActions';
import numbro from 'numbro';
import { useSelectedSheetRow } from '../../data/sheetRow/sheetRowHooks';
var NewCellTemplate = {
    id: undefined,
    description: '',
    value: null,
    jsonData: null,
    tagIds: [],
};
function isEditLineItem(props) {
    return ('lineItemCell' in props &&
        !!props.lineItemCell &&
        isCellRepresentation(props.lineItemCell) &&
        !props.targetTableCell);
}
function isCellRepresentation(cellItem) {
    return 'date' in cellItem && 'id' in cellItem && 'jsonData' in cellItem && 'date' in cellItem;
}
function nonInternalTags(tag) {
    return !(tag === null || tag === void 0 ? void 0 : tag.internalType);
}
function toVersionOption(version) {
    return { label: version.name, value: version.id };
}
function getVersionTag(internalTags, tagIds) {
    var versions = internalTags.versions;
    var versionTag = versions.find(function (_a) {
        var id = _a.id;
        return tagIds.includes(id);
    });
    return versionTag;
}
function mapToCellItem(_a, tagById) {
    var id = _a.id, tagIds = _a.tagIds, value = _a.value, jsonData = _a.jsonData, description = _a.description, date = _a.date, versionTag = _a.versionTag, monthTag = _a.monthTag, yearTag = _a.yearTag;
    return {
        id: id !== null && id !== void 0 ? id : 0,
        tagIds: tagIds.filter(function (id) { return !(id === (versionTag === null || versionTag === void 0 ? void 0 : versionTag.id) || id === (monthTag === null || monthTag === void 0 ? void 0 : monthTag.id) || id === (yearTag === null || yearTag === void 0 ? void 0 : yearTag.id)); }),
        nonInternalTags: tagIds.map(function (id) { return tagById[id] || null; }).filter(nonInternalTags),
        value: value !== null && value !== void 0 ? value : undefined,
        jsonData: jsonData !== null && jsonData !== void 0 ? jsonData : '{}',
        description: description !== null && description !== void 0 ? description : '',
        date: date !== null && date !== void 0 ? date : new Date(),
        versionTagId: versionTag === null || versionTag === void 0 ? void 0 : versionTag.id,
        yearTagId: yearTag === null || yearTag === void 0 ? void 0 : yearTag.id,
        monthTagId: monthTag === null || monthTag === void 0 ? void 0 : monthTag.id,
    };
}
function refillTagIds(monthTagId, versionTagId, yearTagId, tagIds) {
    if (monthTagId) {
        tagIds.push(monthTagId);
    }
    if (yearTagId) {
        tagIds.push(yearTagId);
    }
    if (versionTagId) {
        tagIds.push(versionTagId);
    }
}
function mapCellItemToUpdateCellRequest(_a) {
    var tagIds = _a.tagIds, value = _a.value, id = _a.id, date = _a.date, description = _a.description, jsonData = _a.jsonData, monthTagId = _a.monthTagId, versionTagId = _a.versionTagId, yearTagId = _a.yearTagId;
    var newTagIds = __spreadArray([], __read(tagIds), false).filter(function (id) { return !(id === versionTagId || id === monthTagId || id === yearTagId); });
    refillTagIds(monthTagId, versionTagId, yearTagId, newTagIds);
    return {
        id: id,
        tagIds: newTagIds,
        value: value !== null && value !== void 0 ? value : null,
        date: date,
        description: description,
        jsonData: jsonData,
        status: CellStatus.DEFAULT,
    };
}
function mapCellItemToCreateCellRequest(_a) {
    var tagIds = _a.tagIds, value = _a.value, date = _a.date, description = _a.description, jsonData = _a.jsonData, monthTagId = _a.monthTagId, versionTagId = _a.versionTagId, yearTagId = _a.yearTagId;
    var newTagIds = __spreadArray([], __read(tagIds), false);
    refillTagIds(monthTagId, versionTagId, yearTagId, newTagIds);
    return {
        tagIds: newTagIds,
        value: value !== null && value !== void 0 ? value : null,
        date: date,
        description: description,
        jsonData: jsonData,
        status: CellStatus.DEFAULT,
    };
}
function initStateInitializer(props, internalTags, selectedSheetRow, tagById, offset) {
    return function () {
        var _a;
        if (isEditLineItem(props)) {
            var lineItemCell = props.lineItemCell;
            var copy = __assign({}, lineItemCell);
            var timeTags_1 = getTimeTags(internalTags, copy.tagIds);
            var versionTag_1 = getVersionTag(internalTags, copy.tagIds);
            return mapToCellItem(__assign(__assign(__assign({}, copy), { versionTag: versionTag_1 }), timeTags_1), tagById);
        }
        var targetTableCell = props.targetTableCell;
        if (!targetTableCell) {
            var date_1 = new Date();
            date_1.setHours(12);
            var tagIds = (_a = selectedSheetRow === null || selectedSheetRow === void 0 ? void 0 : selectedSheetRow.allTags.map(function (_a) {
                var id = _a.id;
                return id;
            })) !== null && _a !== void 0 ? _a : [];
            var timeTags_2 = getTimeTagsFromDate(date_1, internalTags);
            return mapToCellItem(__assign(__assign(__assign(__assign({}, NewCellTemplate), { tagIds: tagIds }), timeTags_2), { date: date_1 }), tagById);
        }
        var timeTags = getTimeTags(internalTags, targetTableCell.tagIds);
        var versionTag = getVersionTag(internalTags, targetTableCell.tagIds);
        var date = getDateFromTags(timeTags, offset);
        return mapToCellItem(__assign(__assign(__assign(__assign({}, targetTableCell), { value: null, date: date, jsonData: null, description: '' }), timeTags), { versionTag: versionTag }), tagById);
    };
}
function getTimeTagsFromDate(date, internalTags) {
    var monthTag = internalTags.months.find(function (m) { var _a; return m.order === ((_a = date.getMonth) === null || _a === void 0 ? void 0 : _a.call(date)) + 1; });
    var yearTag = internalTags.years.find(function (y) { return y.order === date.getFullYear(); });
    return { monthTag: monthTag, yearTag: yearTag };
}
function getTimeTags(internalTags, tagIds) {
    var months = internalTags.months, years = internalTags.years;
    var monthTag = months.find(function (_a) {
        var id = _a.id;
        return tagIds.includes(id);
    });
    var yearTag = years.find(function (_a) {
        var id = _a.id;
        return tagIds.includes(id);
    });
    return { yearTag: yearTag, monthTag: monthTag };
}
function getDateRangeFromTimeTags(internalTags) {
    var years = internalTags.years.map(function (_a) {
        var order = _a.order;
        return order;
    });
    var max = Math.max.apply(Math, __spreadArray([], __read(years), false));
    var min = Math.min.apply(Math, __spreadArray([], __read(years), false));
    var from = new Date(min, 0, 1);
    var to = new Date(max, 11, 0);
    return { from: from, to: to };
}
function getDateFromTags(_a, fiscalMonth) {
    var yearTag = _a.yearTag, monthTag = _a.monthTag;
    if (!(monthTag && yearTag)) {
        return new Date();
    }
    var month = +monthTag.name.replace('M', '');
    var year = +yearTag.name.replace('Y', '');
    var offsetMonth = month - 1 + fiscalMonth - 1;
    if (offsetMonth > 11) {
        return new Date(year, offsetMonth - 12, 1, 12);
    }
    return new Date(year, offsetMonth, 1, 12);
}
var LineItemModalBla = function (props) {
    var _a, _b;
    var L = useLanguage().L;
    var queryClient = useQueryClient();
    var tagData = useTagContext().tagData;
    var createTag = useTagActions().createTag;
    var selectedSheetRow = useSelectedSheetRow();
    var financialYearStartingMonth = useSetting(SettingType.FinancialYearStartingMonth);
    var stateInit = initStateInitializer(props, tagData.internalTagsMap, selectedSheetRow, tagData.tagById, +((_a = financialYearStartingMonth === null || financialYearStartingMonth === void 0 ? void 0 : financialYearStartingMonth.value) !== null && _a !== void 0 ? _a : 1));
    var _c = __read(useState(stateInit), 2), item = _c[0], setItem = _c[1];
    var _d = __read(useState({}), 2), errors = _d[0], setErrors = _d[1];
    var _e = __read(useState(item.value ? "".concat(item.value) : ''), 2), value = _e[0], setValue = _e[1];
    var save = function () { return __awaiter(void 0, void 0, void 0, function () {
        var updatePayload, createPayload;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!isValid(item)) {
                        return [2 /*return*/];
                    }
                    if (!isEditLineItem(props)) return [3 /*break*/, 2];
                    updatePayload = mapCellItemToUpdateCellRequest(item);
                    return [4 /*yield*/, updateCell(updatePayload)];
                case 1:
                    _b.sent();
                    //Temporary fix
                    queryClient.invalidateQueries(cellKeys.listItemsTables());
                    ModalManager.closeModal();
                    return [2 /*return*/];
                case 2:
                    createPayload = mapCellItemToCreateCellRequest(item);
                    return [4 /*yield*/, createCell(createPayload)];
                case 3:
                    _b.sent();
                    //Temporary fix
                    queryClient.invalidateQueries(cellKeys.listItemsTables());
                    (_a = props === null || props === void 0 ? void 0 : props.invalidator) === null || _a === void 0 ? void 0 : _a.call(props);
                    ModalManager.closeModal();
                    return [2 /*return*/];
            }
        });
    }); };
    var isValid = function (item) {
        var errors = {};
        if (!(item === null || item === void 0 ? void 0 : item.value)) {
            errors.value = 'List item value is required and must be a number';
        }
        if (!item.tagIds.some(function (id) { var _a; return ((_a = tagData.tagById[id]) === null || _a === void 0 ? void 0 : _a.type) === TagType.Account; })) {
            errors.tagIds = 'Account tag is required';
        }
        if (!item.versionTagId) {
            errors.versionTagId = 'Version is requred';
        }
        setErrors(errors);
        return !Object.keys(errors).length;
    };
    function handleChange(e) {
        var key = e.target.name;
        var value = e.target.value;
        if (!(key in item)) {
            return;
        }
        var copy = __assign({}, item);
        if (key === 'value') {
            setValue(value);
            var parsedValue = numbro.unformat(value);
            var itemValue = parsedValue === undefined || Number.isNaN(parsedValue) ? undefined : parsedValue;
            copy[key] = itemValue;
            setItem(copy);
            return;
        }
        if (key === 'description') {
            copy[key] = value;
            setItem(copy);
        }
        if (key === 'versionTagId') {
            copy[key] = Number(value);
            setItem(copy);
        }
    }
    var onChangeJSONDataField = function (fieldUuid, value) {
        var jsonData;
        if (typeof item.jsonData === 'string') {
            jsonData = JSON.parse(item.jsonData);
        }
        if (item.jsonData === null) {
            jsonData = {};
        }
        jsonData[fieldUuid] = value;
        var it = __assign({}, item);
        it.jsonData = JSON.stringify(jsonData);
        setItem(it);
    };
    var updateDate = function (date) {
        var _a = getTimeTagsFromDate(date, tagData.internalTagsMap), monthTag = _a.monthTag, yearTag = _a.yearTag;
        if (monthTag && yearTag) {
            setItem(__assign(__assign({}, item), { monthTagId: monthTag.id, yearTagId: yearTag.id, date: date }));
        }
        else {
            console.error('Selected date is out of enabled range!');
        }
    };
    var onChangeParams = function (params) {
        var it = __assign({}, item);
        for (var key in params) {
            if (Object.prototype.hasOwnProperty.call(params, key)) {
                //@ts-ignore
                it[key] = params[key];
            }
        }
        setItem(it);
    };
    var createLiTag = function (tagName) { return __awaiter(void 0, void 0, void 0, function () {
        var tag, copy, newTag;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    tag = tagData.getTagByNameAndParent(tagName, null);
                    copy = __assign({}, item);
                    if (tag) {
                        copy.nonInternalTags = __spreadArray(__spreadArray([], __read(copy.nonInternalTags), false), [tag], false);
                        copy.tagIds = __spreadArray(__spreadArray([], __read(copy.tagIds), false), [tag.id], false);
                        setItem(copy);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, createTag({ name: tagName, ParentId: null, description: '' })];
                case 1:
                    newTag = _a.sent();
                    if (newTag) {
                        copy.nonInternalTags = __spreadArray(__spreadArray([], __read(copy.nonInternalTags), false), [newTag], false);
                        copy.tagIds = __spreadArray(__spreadArray([], __read(copy.tagIds), false), [newTag.id], false);
                        setItem(copy);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var selectLiTag = function (tagId) {
        var tag = tagData.tagById[tagId];
        if (tag) {
            var copy = __assign({}, item);
            copy.tagIds = __spreadArray(__spreadArray([], __read(copy.tagIds), false), [tagId], false);
            copy.nonInternalTags = __spreadArray(__spreadArray([], __read(copy.nonInternalTags), false), [tag], false);
            setItem(copy);
        }
    };
    var removeLiTag = function (tagId) {
        var copy = __assign({}, item);
        copy.tagIds = copy.tagIds.filter(function (id) { return id !== tagId; });
        copy.nonInternalTags = copy.nonInternalTags.filter(function (_a) {
            var id = _a.id;
            return id !== tagId;
        });
        setItem(copy);
    };
    var title = isEditLineItem(props) ? L('Edit entry') : L('New entry by date');
    var versionOptions = tagData.internalTagsMap.versions.map(toVersionOption);
    var dateRange = getDateRangeFromTimeTags(tagData.internalTagsMap);
    return (React.createElement(Modal, { width: "600" },
        React.createElement(ModalHeader, { title: title }),
        React.createElement(ModalBody, null,
            React.createElement("form", null,
                React.createElement(FormField, { "$bottomSpace": true },
                    React.createElement(FormFieldLabel, null, L('Date')),
                    React.createElement(DatePicker, { callback: updateDate, date: item.date, from: dateRange.from, to: dateRange.to })),
                React.createElement(FeatureWrapper, { featureKey: "canSeeListItemDescription" },
                    React.createElement(TextArea, { label: L('Description'), value: (_b = item.description) !== null && _b !== void 0 ? _b : '', name: "description", onChange: handleChange, bottomMargin: true })),
                React.createElement(SelectInput, { name: "versionTagId", searchable: true, label: L('Version'), options: versionOptions, placeholder: "Version", value: item.versionTagId || null, onChange: function (e) { return handleChange(e); }, invalidString: errors.versionTagId, bottomMargin: true }),
                React.createElement(TextInput, { label: L('Value'), name: "value", onChange: function (e) { return handleChange(e); }, value: value, invalidString: errors.value, bottomMargin: true }),
                React.createElement(FeatureWrapper, { featureKey: "canSeeListItemTags" },
                    React.createElement(FormField, { "$bottomSpace": true },
                        React.createElement(FormFieldLabel, null, L('Tags')),
                        React.createElement(Tags, { canUpdate: true, tags: item.nonInternalTags, create: createLiTag, select: selectLiTag, remove: removeLiTag, placeholder: L('Add tag') }),
                        errors.tagIds && React.createElement(FormFieldErrorHelp, null, errors.tagIds))))),
        React.createElement(ModalFooter, { done: save })));
};
var LineItemModal = function (props) {
    var Root = useRoot(baobab.root);
    return (React.createElement(Root, null,
        React.createElement(LineItemModalBla, __assign({}, props))));
};
export { LineItemModal };
